import script from "./Step1DatosPersonales.vue?vue&type=script&setup=true&lang=js"
export * from "./Step1DatosPersonales.vue?vue&type=script&setup=true&lang=js"

import "./Step1DatosPersonales.vue?vue&type=style&index=0&id=e6b05e02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6b05e02"]])

export default __exports__